import { forwardRef, type TextareaHTMLAttributes } from 'react';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

/** Multiline input matching TextInput's token styling. Works inside FormField. */
export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea(
  { invalid, style, rows = 3, onFocus, onBlur, ...rest },
  ref,
) {
  return (
    <textarea
      {...rest}
      ref={ref}
      rows={rows}
      style={{
        width: '100%',
        padding: '10px 12px',
        borderRadius: 'var(--r-2)',
        border: `1px solid ${invalid ? 'var(--danger)' : 'var(--glass-line-2)'}`,
        background: 'var(--surface)',
        color: 'var(--text)',
        fontSize: 'var(--t-md)',
        fontFamily: 'inherit',
        outline: 'none',
        resize: 'vertical',
        ...style,
      }}
      onFocus={(e) => { e.currentTarget.style.borderColor = invalid ? 'var(--danger)' : 'var(--accent)'; onFocus?.(e); }}
      onBlur={(e) => { e.currentTarget.style.borderColor = invalid ? 'var(--danger)' : 'var(--glass-line-2)'; onBlur?.(e); }}
    />
  );
});
